import React, { Component } from 'react';
import axios from 'axios';
import PropTypes from 'prop-types';
import { message } from 'antd';
import { tomcatHost, herokuProxyHost } from '../../config/properties';

// Local Deps
import {
  requestSolicitationDetail,
  solicitationStatus,
} from './graphql';

// import { getOrgByID } from '../../graphql';

let solStatus = '';
let quotable = '';

export default function SolicitationDetailHOC(SolicitationDetail) {
  class SolicitationDetailWrapper extends Component {
    static propTypes = {
      solicitationId: PropTypes.string.isRequired,
      auth: PropTypes.instanceOf(Object).isRequired,
    };

    state = {
      isLoading: true,
      solicitationId: '',
      castingType: '',
      dateIssued: '',
      purchaseRequest: [
        {
          purchaseRequestNumber: '',
          nsnPart: '',
          fscCode: '',
        },
      ],
      srva: '',
      attachmentLinks: [],
      procurementHistory: [],
      Drawings: '',
      RecentSolicitations: [],
      TechnicalChar: '',
      itemDescription: {},
      PackagingInfo: '',
      setAside: '0',
      wsdcs: [],
      um: '',
      refNbrs: [],
      process: '',
      materialsMethods: [],
      showDownload: false,
      showDownloadDrawingsModal: false,
      modalRfqOpen: false,
      modalProcGroupVisible: false,
      options: [],
      rfqInput: { solNum: this.props.solicitationId },
    };

    async componentDidMount() {
      const {
        solicitation: solicitationResult,
      } = await requestSolicitationDetail(this.props.solicitationId);

      if (solicitationResult.solicitation) {
        const solicitations = solicitationResult.solicitation;
        Object.keys(solicitations).forEach(key => {
          if (solicitations[key] == null) solicitations[key] = [];
        });
        quotable = solicitationResult.solicitation.quotable;

        await solicitationStatus(this.props.solicitationId)
          .then(res => {
            solStatus = res.solicitationStatus.status;
          })
          .catch(error => {
            console.log(error);
          });
        this.setState(solicitations);

        const niin = solicitations && solicitations.purchaseRequest ? solicitations.purchaseRequest.nsnPart : null;
        const partDesc = solicitations && solicitations.purchaseRequest ? solicitations.purchaseRequest.nomenclature : null;
        const drawings = solicitations ? solicitations.drawings : null;
        let drawingNums = drawings && drawings[0] ? drawings[0].drawingNo : null;
        if (drawings) {
          for (let i = 1; i < drawings.length; i++) {
            if (drawingNums.length + drawings[i].drawingNo.length <= 48) {
              drawingNums += `, ${drawings[i].drawingNo}`
            } else break;
          }
        }
        this.setState({
          rfqInput: {
            solNum: this.props.solicitationId,
            niin,
            partDesc,
            drawingNums,
          }
        });
        this.setState({ isLoading: false });
      }
    }

    async componentDidUpdate() {
      if (solStatus === "Open" && quotable === "true") {
        if (document.getElementById('dibbsQuote')) {
          document.getElementById('dibbsQuote').style.display = 'inline-block';
        }
      } else {
        if (document.getElementById('dibbsQuote')) {
          document.getElementById('dibbsQuote').style.display = 'none';
        }
      }
    }

    handleDownloadDrawingsCancel = () => {
      this.setState({
        showDownloadDrawingsModal: false,
      });
    };
    handleDownloadDrawingsOk = () => {
      const url = `https://pcf1x.bsm.dla.mil/cfolders(bD1lbiZjPTEwMCZkPW1pbg==)/fol_de.htm?p_sol_no=${this.props.solicitationId
        }`;
      window.open(url, '_blank');
    };

    handleDIBBSQuote = async solNumber => {
      // const org = await getOrgByID(this.props.auth.organizationId);
      axios.get(`${herokuProxyHost}/${tomcatHost}/dibbs/quote/cage/${this.props.auth.cageCode}/solnum/${solNumber}`).then(resp => {
        if (resp.data.status !== 'success') {
          const postBody = {
            solNum: solNumber,
            cage: this.props.auth.cageCode,
            email: this.props.auth.email
          }
          axios.post(`${herokuProxyHost}/${tomcatHost}/dibbs/quote/add`, postBody).then((res) => {
            console.log('axios add new disbbsQuote => ', res);
            window.open(`/contractcenter/dibbs?solNum=${solNumber}`, '_self');
          }).catch((err) => {
            console.error({ msg: 'Error adding new dibbs quote to DB2!', postBody }, err);
          });
        } else {
          window.open(`/contractcenter/dibbs?solNum=${solNumber}`, '_self');
        }
      })
        .catch(error => {
          console.log(error);
        });
    }

    downloadSelected = showDownload => {
      this.setState({
        showDownload,
      });
    };

    openDownloadDrawingsModal = () => {
      this.setState({
        showDownloadDrawingsModal: true,
      });
    };

    openRfqModal = async () => {
      // const org = await getOrgByID(this.props.auth.organizationId);
      if (this.props.auth.permissions && this.props.auth.permissions.includes(1)) {
        this.setState({
          modalRfqOpen: true,
        });
      } else {
        if (this.props.auth.cageCode.startsWith('OG')) {
          message.warn({
            content: 'Currently you do not have permissions to use Send RFQ. Please contact support. Be sure to logout and relogin after the permissions have been given.',
            style: {
              marginTop: '10vh',
            },
          }, 6);
        } else if (!this.props.auth.cageCode.startsWith('OG') && this.props.auth.cageCode.startsWith('O')) {
          this.setState({
            modalProcGroupVisible: true,
          })
        } else {
          message.warn({
            content: 'Your account does not have permission to submit RFQs, your organization administrator can enable this permission in your user profile.',
            style: {
              marginTop: '10vh',
            },
          }, 6);
        }
      }
    };

    closeRfqModal = () => {
      this.setState({ modalRfqOpen: false });
    };
    closeProcGroupModal = () => {
      this.setState({ modalProcGroupVisible: false });
    };
    render() {
      const { auth } = this.props;
      return (
        <SolicitationDetail
          handleDownloadDrawingsCancel={this.handleDownloadDrawingsCancel}
          handleDownloadDrawingsOk={this.handleDownloadDrawingsOk}
          showDownloadDrawingsModal={this.state.showDownloadDrawingsModal}
          openDownloadDrawingsModal={this.openDownloadDrawingsModal}
          downloadSelected={this.downloadSelected}
          auth={auth}
          onRadioChange={this.onRadioChange}
          onSelectChange={this.onSelectChange}
          closeRfqModal={this.closeRfqModal}
          closeProcGroupModal={this.closeProcGroupModal}
          handleDIBBSQuote={this.handleDIBBSQuote}
          openRfqModal={this.openRfqModal}
          {...this.state}
        />
      );
    }
  }

  return SolicitationDetailWrapper;
}



// WEBPACK FOOTER //
// ./src/pages/SolicitationDetail/SolicitationDetailHOC.jsx